import { defineStore } from 'pinia';

export const useAffiliatesStore = defineStore('affiliates', {
	actions: {
		getLandingPage(payload) {
			return global.axios.get(process.env.VUE_APP_API_URL + '/affiliates', { headers: { 'Accept': 'application/json' }, params: payload }).then((response) => {
				// Clear existing affiliate cookies to prevent mixing old and new tracking data
				this.clearCookie('af_btag');
				this.clearCookie('af_link');
				this.clearCookie('af_banner');

				// Set cookies
				if (payload.btag) {
					if (payload.btag.includes('_')) {
						const [btag_part, link_part] = payload.btag.split('_l');
						this.setCookie('af_btag', btag_part, 43200);
						if (link_part) {
							this.setCookie('af_link', link_part, 43200);
						}
					} else {
						this.setCookie('af_btag', payload.btag, 43200);
					}
				}

				if (payload.link) {
					this.setCookie('af_link', payload.link, 43200);
				}

				if (payload.banner) {
					this.setCookie('af_banner', payload.banner, 43200);
				}

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error);
			});
		},

		setCookie(name, value, minutes) {
			const expires = new Date();
			expires.setTime(expires.getTime() + (minutes * 60 * 1000));
			document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/';
		},

		clearCookie(name) {
			document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
		}
	}
})